export const DepartmentRouting = [
  {
    path: "/organization/department/list",
    name: "basic-organization-department-list",
    meta: { title: "组织架构" },
    component: () =>
      import(
        /* webpackChunkName: "basic-organization-department" */ "@/views/organization/department/list/index.vue"
      ),
  },
];
